import React from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";

// Fix default marker icon issue
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

const EmployeeMap = ({ punchIn, punchOut }) => {
  if (!punchIn && !punchOut) {
    return <p>No location data available</p>;
  }

  // Default center → Punch In location if available
  const center = punchIn
    ? [punchIn.location.lat, punchIn.location.lng]
    : [punchOut.location.lat, punchOut.location.lng];

  return (
    <MapContainer
      center={center}
      zoom={15}
      style={{ height: "400px", width: "100%", borderRadius: "10px" }}
    >
      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution="© OpenStreetMap contributors"
      />

      {punchIn && (
        <Marker position={[punchIn.location.lat, punchIn.location.lng]}>
          <Popup>
            <b>Punch In</b> <br />
            Time: {new Date(punchIn.time).toLocaleTimeString()} <br />
            Address: {punchIn.location.address}
          </Popup>
        </Marker>
      )}

      {punchOut && (
        <Marker position={[punchOut.location.lat, punchOut.location.lng]}>
          <Popup>
            <b>Punch Out</b> <br />
            Time: {new Date(punchOut.time).toLocaleTimeString()} <br />
            Address: {punchOut.location.address}
          </Popup>
        </Marker>
      )}
    </MapContainer>
  );
};

export default EmployeeMap;
